import type { SSRData } from '@urql/vue';

import { getConfig } from '../config/constants';

import getWaiverClient, { ssr as waiverSsr } from '~/graphql/waiver/getWaiverClient';
import getPartnerPortalClient, { ssr as ppSsr } from '~/graphql/pp/getPartnerPortalClient';

const waiverSsrKey = '__URQL_WAIVER_DATA__';
const ppSsrKey = '__URQL_PP_DATA__';

export default defineNuxtPlugin((nuxt) => {
  const { vueApp } = nuxt;

  if (import.meta.client) {
    nuxt.hook('app:created', () => {
      waiverSsr.restoreData(nuxt.payload[waiverSsrKey] as SSRData);
      ppSsr.restoreData(nuxt.payload[ppSsrKey] as SSRData);
    });
  }

  if (import.meta.server) {
    nuxt.hook('app:rendered', () => {
      nuxt.payload[waiverSsrKey] = waiverSsr.extractData();
      nuxt.payload[ppSsrKey] = ppSsr.extractData();
    });
  }

  const config = getConfig(useRuntimeConfig());

  const waiverClient = getWaiverClient(config.domains.api);
  nuxt.provide('urql-waiver', waiverClient);
  vueApp.provide('urql-waiver', ref(waiverClient));

  const partnerPortalClient = getPartnerPortalClient(config.domains.api);
  nuxt.provide('urql-pp', partnerPortalClient);
  vueApp.provide('urql-pp', ref(partnerPortalClient));
});
